if (typeof window.Shopify === 'undefined') window.Shopify = {};

if (typeof window.Shopify.formatMoney !== 'function') {
  window.Shopify.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    let value = '';
    const formatString = format || window.Shopify.money_format || '{{amount}}';

    function defaultOption(opt, def) {
      return typeof opt === 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) return 0;

      number = (number / 100).toFixed(precision);

      const parts = number.split('.');
      const dollars = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      const cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(/\{\{\s*(\w+)\s*\}\}/)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(/\{\{\s*\w+\s*\}\}/, value);
  };
}

function resizeImage(src, size) {
  if (!src) return '';
  return src.replace(/(\.[^/.]+$)/, `_${size}$1`);
}

document.addEventListener('DOMContentLoaded', () => {
  SSswiperAll();
  SSnavTabs();
  SSaccordion();
  reinitView();
  initMenus();
  SSinitImagePopup('.popup-gallery');
  initCountd();
  window.smartaddonSS = window.smartaddonSS || {};  

  const goToTop = document.getElementById("goToTop");

  if (goToTop) {
    // Ẩn ban đầu
    goToTop.classList.add("hidden-top");

    // Theo dõi cuộn trang
    window.addEventListener("scroll", () => {
      if (window.scrollY === 0) {
        goToTop.classList.add("hidden-top");
      } else {
        goToTop.classList.remove("hidden-top");
      }
    });

    // Cuộn lên đầu trang
    goToTop.addEventListener("click", (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth", // cuộn mượt như butter
      });
    });
  }

  document.querySelectorAll(".js-counter").forEach(el => {
      let start = 0;
      let end = parseInt(el.innerText.replace(/\D/g,'')); // lấy số, phòng khi text lẫn ký tự khác
      let duration = 5000; // tốc độ chạy
      let startTime = null;

      function animateCounter(timestamp) {
          if (!startTime) startTime = timestamp;
          let progress = Math.min((timestamp - startTime) / duration, 1);

          let current = Math.ceil(progress * end);
          el.innerText = current;

          if (progress < 1) requestAnimationFrame(animateCounter);
      }

      requestAnimationFrame(animateCounter);
  });

});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}


class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();

    const targetIndex =
      this.sliderControlLinksArray.indexOf(event.currentTarget);

    const targetSlide = this.sliderItems[targetIndex];
    if (!targetSlide) return;

    targetSlide.scrollIntoView({
      behavior: 'smooth',
      inline: 'start',
      block: 'nearest'
    });
  }

}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.productData = JSON.parse(this.dataset.product);
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      // tìm variant mới dựa trên option đang chọn
      const selectedOptions = Array.from(
        this.querySelectorAll('select option[selected], fieldset input:checked')
      ).map(el => el.value);

      const matchedVariant = this.productData.variants.find(variant =>
        variant.options.every((opt, i) => opt === selectedOptions[i])
      );

      if (matchedVariant) {
        this.updatePrice(matchedVariant,this.productData.id);
        this.updateAddId(matchedVariant,this.productData.id);
        this.updateImage(matchedVariant,this.productData.id);
      }      
      
      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });

      
    });
  }

  updateImage(variant,id) {
    const imageContainer = document.querySelector('.compare-'+id+' .product-card__image');
    if (!imageContainer) return;   
    if(variant.featured_image) {
    const featuredImage = resizeImage(variant.featured_image.src, 'grande');
    imageContainer.src = featuredImage;
    }
  }
  
  updateAddId(variant,id) {
    const idContainer = document.querySelector('.compare-'+id+' .product-variant-id');
    if (!idContainer) return;    
    idContainer.value = variant.id;
  }
  updatePrice(variant,id) {
    const priceContainer = document.querySelector('.compare-'+id+' .price');
    if (!priceContainer) return;

    const regularPrice = priceContainer.querySelector('.price-item--regular');
    const salePrice = priceContainer.querySelector('.price-item--sale');
    if (variant.compare_at_price > variant.price) {
      // Có giảm giá
      if (salePrice) salePrice.textContent = Shopify.formatMoney(variant.price, window.money_format);
      if (regularPrice) regularPrice.textContent = Shopify.formatMoney(variant.compare_at_price, window.money_format);
      priceContainer.classList.add('price--on-sale');
    } else {
      // Không giảm giá
      if (regularPrice) regularPrice.textContent = Shopify.formatMoney(variant.price, window.money_format);
      if (salePrice) salePrice.textContent = '';
      priceContainer.classList.remove('price--on-sale');
    }
  }


  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
    

  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
        initButtonsWishlist();
        initButtonsCompare();
        SSswiperAll();
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll('[data-popup-video]'); // chọn bằng attribute riêng cho an toàn

  links.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();

      const youtubeLink = link.getAttribute('href');
      let split_c, split_n;

      if (youtubeLink.includes('youtube.com')) {
        split_c = 'v=';
        split_n = 1;
      } else if (youtubeLink.includes('youtu.be') || youtubeLink.match(/(vimeo.com\/)+[0-9]/)) {
        split_c = '/';
        split_n = 3;
      } else if (youtubeLink.match(/(vimeo.com\/)+[a-zA-Z]/)) {
        split_c = '/';
        split_n = 5;
      } else {
        return; // không phải link hợp lệ
      }

      const parts = youtubeLink.split(split_c);
      const getID = parts[split_n] || '';
      const cleanID = getID.replace(/(&)+(.*)/, '');

      let videoEmbedLink = '';
      if (youtubeLink.includes('youtube.com') || youtubeLink.includes('youtu.be')) {
        videoEmbedLink = `https://www.youtube.com/embed/${cleanID}?autoplay=1`;
      } else if (youtubeLink.includes('vimeo.com')) {
        videoEmbedLink = `https://player.vimeo.com/video/${cleanID}?autoplay=1`;
      }

      // Tạo HTML popup
      const wrap = document.createElement('div');
      wrap.className = 'YouTubePopUp-Wrap show';
      wrap.innerHTML = `
        <div class="YouTubePopUp-Content">
          <span class="YouTubePopUp-Close"></span>
          <iframe src="${videoEmbedLink}" allowfullscreen></iframe>
        </div>
      `;
      document.body.appendChild(wrap);
      // Đóng popup khi click ngoài hoặc nút close
      wrap.addEventListener('click', e => {
        if (e.target.classList.contains('YouTubePopUp-Wrap') || e.target.classList.contains('YouTubePopUp-Close')) {
          wrap.classList.remove('show');
          wrap.classList.add('hide');
          setTimeout(() => wrap.remove(), 500);
        }
      });

      // ESC để đóng
      document.addEventListener('keyup', escClose);
      function escClose(ev) {
        if (ev.key === 'Escape') {
          wrap.classList.remove('show');
          wrap.classList.add('hide');
          setTimeout(() => wrap.remove(), 500);
          document.removeEventListener('keyup', escClose);
        }
      }
    });
  });
});
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function formatMoney(cents, format = window.money_format || "${{amount}}") {
  if (typeof cents === "string") cents = cents.replace(".", "");
  let value = "";
  let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) return 0;
    number = (number / 100.0).toFixed(precision);

    let parts = number.split(".");
    let dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    let centsPart = parts[1] ? decimal + parts[1] : "";
    return dollars + centsPart;
  }

  switch (format.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
  }

  return format.replace(placeholderRegex, value);
}

function getProduct(handle, callback) {
  fetch(`/products/${handle}.js`)
    .then(response => {
      if (!response.ok) throw new Error('Product not found');
      return response.json();
    })
    .then(product => callback(product))
    .catch(error => console.error('Error loading product:', error));
}

function resizeShopifyImage(src, size = 'grande') {
  if (!src) return '';
  const parts = src.split('?');
  const url = parts[0];
  const query = parts[1] ? '?' + parts[1] : '';
  return url.replace(/(\.(jpg|jpeg|png|gif|webp|avif))$/i, `_${size}$1`) + query;
}

// ---------------------------
// Hàm slideToggle thuần JS
// ---------------------------
function slideToggle(el, duration = 300) {
    if (!el || el._sliding) return;
    el._sliding = true;

    const isHidden = getComputedStyle(el).display === 'none';

    if (isHidden) {
      el.style.display = 'block';
      const height = el.scrollHeight + 'px';
      el.style.height = '0px';
      el.style.overflow = 'hidden';
      el.offsetHeight; // force reflow
      el.style.transition = `height ${duration}ms ease, opacity ${duration}ms ease`;
      el.style.height = height;
      el.style.opacity = '1';

      setTimeout(() => {
        el.style.height = 'auto';
        el.style.overflow = '';
        el.classList.add('open');
        el._sliding = false;
      }, duration);
    } else {
      const height = el.scrollHeight + 'px';
      el.style.height = height;
      el.style.overflow = 'hidden';
      el.offsetHeight;
      el.style.transition = `height ${duration}ms ease, opacity ${duration}ms ease`;
      el.style.height = '0px';
      el.style.opacity = '0';

      setTimeout(() => {
        el.style.display = 'none';
        el.style.height = '';
        el.style.overflow = '';
        el.classList.remove('open');
        el._sliding = false;
      }, duration);
    }
  }

  // ---------------------------
  // Toggle menu chính
  // ---------------------------
  document.addEventListener('DOMContentLoaded', () => {
    const carets = document.querySelectorAll('.toggle-menu .caret');

    carets.forEach(caret => {
      caret.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const parentItem = this.closest('.toggle-menu');
        const dropdown = parentItem.querySelector('.sub-menu');
        if (!dropdown) return;

        // Accordion behavior: đóng các menu khác
        document.querySelectorAll('.sub-menu.open').forEach(openEl => {
          if (openEl !== dropdown) {
           // slideToggle(openEl, 300);
          }
        });

        // Toggle menu hiện tại
        slideToggle(dropdown, 300);
      });
    });
}); 

function smartaddonSS(settings) {
}

smartaddonSS.Sections = function () {
  this.constructors = {};
  this.instances = [];
};

Object.assign(smartaddonSS.Sections.prototype, {
  _createInstance(container, constructor) {
    const el = container instanceof HTMLElement ? container : document.querySelector(container);
    const id = el.getAttribute('data-section-id');
    const type = el.getAttribute('data-section-type');
    constructor = constructor || this.constructors[type];
    if (!constructor) return;

    const instance = Object.assign(new constructor(container), {
      id,
      type,
      container: el,
    });
    this.instances.push(instance);
  },

  _onSectionLoad(evt) {
    const container = evt.target.querySelector('[data-section-id]');
    if (container) this._createInstance(container);
  },

  _onSectionUnload(evt) {
    const sectionId = evt.detail.sectionId;
    this.instances = this.instances.filter(instance => {
      const match = instance.id === sectionId;
      if (match && typeof instance.onUnload === 'function') instance.onUnload(evt);
      return !match;
    });
  },

  _onSelect(evt) {
    const id = evt.detail.sectionId;
    const instance = this.instances.find(i => i.id === id);
    if (instance?.onSelect) instance.onSelect(evt);
  },

  _onDeselect(evt) {
    const id = evt.detail.sectionId;
    const instance = this.instances.find(i => i.id === id);
    if (instance?.onDeselect) instance.onDeselect(evt);
  },

  _onBlockSelect(evt) {
    const id = evt.detail.sectionId;
    const instance = this.instances.find(i => i.id === id);
    if (instance?.onBlockSelect) instance.onBlockSelect(evt);
  },

  _onBlockDeselect(evt) {
    const id = evt.detail.sectionId;
    const instance = this.instances.find(i => i.id === id);
    if (instance?.onBlockDeselect) instance.onBlockDeselect(evt);
  },

  register(type, constructor) {
    this.constructors[type] = constructor;
    document.querySelectorAll(`[data-section-type="${type}"]`).forEach(container => {
      this._createInstance(container, constructor);
    });
  },
});

function reinitView() {

  // Click active button
  document.querySelectorAll('.view-mode button').forEach(btn => {
    btn.addEventListener('click', function () {
      this.parentElement.querySelectorAll('button').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // Helper: change layout
  const setLayout = (selector, className, mode) => {
    document.querySelectorAll('.product-grid').forEach(el => {
      el.className = className;
    });
    localStorage.setItem('grid-3', mode);
  };

  // Grid buttons
  document.getElementById('grid-5')?.addEventListener('click', function () {
    const style = this.dataset.style; 
    setLayout(
        '#grid-5',
        `grid product-grid grid--2-col-tablet-down grid--5-col-desktop ${style}`,
        'grid-5'
    );
  });

  document.getElementById('grid-4')?.addEventListener('click', function () {
      const style = this.dataset.style || 'EndlessClick';
      setLayout(
          '#grid-4',
          `grid product-grid grid--2-col-tablet-down grid--4-col-desktop ${style}`,
          'grid-4'
      );
  });

  document.getElementById('grid-3')?.addEventListener('click', function () {
      const style = this.dataset.style || 'EndlessClick';
      setLayout(
          '#grid-3',
          `grid product-grid grid--2-col-tablet-down grid--3-col-desktop ${style}`,
          'grid-3'
      );
  });

  document.getElementById('grid-2')?.addEventListener('click', function () {
      const style = this.dataset.style || 'EndlessClick';
      setLayout(
          '#grid-2',
          `grid product-grid grid--2-col-tablet-down grid--2-col-desktop ${style}`,
          'grid-2'
      );
  });

  // Restore last view
  const mode = localStorage.getItem('grid-3');

  switch (mode) {
    case 'grid-2':
      document.getElementById('grid-2')?.click();
      break;
    case 'grid-5':
      document.getElementById('grid-5')?.click();
      break;
    case 'grid-4':
      document.getElementById('grid-4')?.click();
      break;
    case 'grid-3':
      document.getElementById('grid-3')?.click();
      break;
    default:
      document.getElementById('grid-6')?.click();
      break;
  }
}


function initCountd() {
  document.querySelectorAll('[data-date]').forEach(function(el) {
    const finalDate = new Date(el.getAttribute('data-date'));
    const finalType = el.getAttribute('data-type');

    function updateCountdown() {
      const now = new Date();
      let diff = Math.floor((finalDate - now) / 1000);

      if (diff <= 0) {
        const countdownTab = el.closest('.countdown_tab');
        const productCountdown = el.closest('.product-countdown');
        if (countdownTab) countdownTab.style.display = 'none';
        if (productCountdown) productCountdown.style.display = 'none';
        clearInterval(timer);
        return;
      }

      const days = Math.floor(diff / (3600 * 24));
      diff -= days * 3600 * 24;
      const hours = Math.floor(diff / 3600);
      diff -= hours * 3600;
      const minutes = Math.floor(diff / 60);
      const seconds = diff % 60;

      if (finalType === 'home-section') {
        el.innerHTML = `
          <div class="deals-time day">
            <div class="num-time">${String(days).padStart(2, '0')}</div>
            <div class="title-time">${window.strings?.days || 'Days'}</div>
          </div>
          <div class="deals-time hour">
            <div class="num-time">${String(hours).padStart(2, '0')}</div>
            <div class="title-time">${window.strings?.hours || 'Hours'}</div>
          </div>
          <div class="deals-time minute">
            <div class="num-time">${String(minutes).padStart(2, '0')}</div>
            <div class="title-time">${window.strings?.minutes || 'Minutes'}</div>
          </div>
          <div class="deals-time second">
            <div class="num-time">${String(seconds).padStart(2, '0')}</div>
            <div class="title-time">${window.strings?.seconds || 'Seconds'}</div>
          </div>
        `;
      } else {
        el.innerHTML = `
          <div class="deals-time day"><div class="num-time">${String(days).padStart(2, '0')}</div><div class="title-time">D</div></div>
          <div class="deals-time hour"><div class="num-time">${String(hours).padStart(2, '0')}</div><div class="title-time">H</div></div>
          <div class="deals-time minute"><div class="num-time">${String(minutes).padStart(2, '0')}</div><div class="title-time">M</div></div>
          <div class="deals-time second"><div class="num-time">${String(seconds).padStart(2, '0')}</div><div class="title-time">S</div></div>
        `;
      }
    }

    updateCountdown(); // chạy ngay lần đầu
    const timer = setInterval(updateCountdown, 1000);
  });
}


async function getAllCategoryFilters() {
  try {
    const res = await fetch('/collections/all?section_id=main-collection-product-grid');
    const html = await res.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // Tìm form CollectionFiltersForm
    const filterForm = doc.querySelector('#product-grid');
    if (!filterForm) {
      console.warn('Không tìm thấy #product-grid trong HTML.');
      return [];
    }

    // Tìm input ẩn chứa JSON filter
    const filterScript = filterForm.querySelector('script[type="application/json"]');
    if (!filterScript) {
      console.warn('Không có JSON filter trong form.');
      return [];
    }

    const filterData = JSON.parse(filterScript.textContent);
    const filters = filterData.filters || [];

    // Lấy filter category
    const categoryFilter = filters.find(f => f.param_name === 'filter.p.t.category');
    if (!categoryFilter) {
      console.warn('Không có filter.p.t.category.');
      return [];
    }

    // Trả về danh sách category
    return categoryFilter.values.map(v => ({
      label: v.label,
      value: v.value,
      url: v.url_to_add,
      count: v.count,
      active: v.active
    }));
  } catch (err) {
    console.error('Lỗi khi lấy filter category:', err);
    return [];
  }
}

getAllCategoryFilters().then(categories => {
  const container = document.getElementById("categoryFilter");
  if (!container) {
    console.warn("Không tìm thấy #categoryFilter trong HTML.");
    return;
  }
  if (!categories.length) {
    container.innerHTML = `<option disabled>${window.strings.no_categories}</option>`;
    return;
  }
  
  const urlParams = new URLSearchParams(window.location.search);
  const currentCategory = urlParams.get('filter.p.t.category');
  let html = ``;
  html += `<option value=''>${window.strings.all_categories}</option>`;
  categories.forEach(cat => {
    const isSelected = currentCategory === cat.value;
    html += `
      <option value="${cat.value}" ${isSelected ? 'selected' : ''}>
        ${cat.label} (${cat.count})
      </option>
    `;
  });
  container.innerHTML = html;
});

function initMenus() {
  // OFFCANVAS MENU
  const mobMenu = document.querySelector('.mob-menu');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileScreen = document.querySelector('.mobile-screen');
  const menuRemove = document.querySelector('.navigation-mobile .menu-remove');
  const html = document.documentElement;

  if (mobMenu && mobileMenu && mobileScreen) {
    mobMenu.addEventListener('click', e => {
      e.preventDefault();
      mobileMenu.classList.toggle('nav-open');
      mobileScreen.classList.add('nav-open');
      html.classList.toggle('no-scroll');
    });

    mobileScreen.addEventListener('click', e => {
      e.preventDefault();
      mobileScreen.classList.toggle('nav-open');
      mobileMenu.classList.remove('nav-open');
      html.classList.remove('no-scroll');
    });
  }

  if (menuRemove) {
    menuRemove.addEventListener('click', e => {
      e.preventDefault();
      mobileScreen.classList.remove('nav-open');
      mobileMenu.classList.remove('nav-open');
      html.classList.remove('no-scroll');
    });
  }

  // VERTICAL MENU
  const showVerticalMenu = document.querySelector('#show-verticalmenu');
  const verticalWrapper = document.querySelector('.vertical-wrapper');
  const verticalScreen = document.querySelector('.vertical-screen');
  const closeVertical = document.querySelector('.close-vertical');

  if (showVerticalMenu && verticalWrapper && verticalScreen) {
    showVerticalMenu.addEventListener('click', e => {
      e.preventDefault();
      verticalWrapper.classList.toggle('vertical-open');
      verticalScreen.classList.add('vertical-open');
      html.classList.toggle('no-scroll');
    });

    verticalScreen.addEventListener('click', e => {
      e.preventDefault();
      verticalScreen.classList.toggle('vertical-open');
      verticalWrapper.classList.remove('vertical-open');
      html.classList.remove('no-scroll');
    });
  }

  if (closeVertical) {
    closeVertical.addEventListener('click', e => {
      e.preventDefault();
      verticalScreen.classList.remove('vertical-open');
      verticalWrapper.classList.remove('vertical-open');
      html.classList.remove('no-scroll');
    });
  }
}

function SSinitImagePopup(selector) {
  // Tạo popup HTML một lần
  const popup = document.createElement('div');
  popup.className = 'popup';
  popup.innerHTML = `
    <span class="close">&times;</span>
    <img id="popup-img">
    <div class="nav prev">&#10094;</div>
    <div class="nav next">&#10095;</div>
  `;
  document.body.appendChild(popup);

  const popupImg = popup.querySelector('#popup-img');
  const closeBtn = popup.querySelector('.close');
  const nextBtn = popup.querySelector('.next');
  const prevBtn = popup.querySelector('.prev');
  const imgs = document.querySelectorAll(selector);
  const imgs2 = document.querySelectorAll(selector+' img');
  let currentIndex = 0;

  // Khi click vào ảnh => mở popup
  imgs.forEach((img, index) => {
    img.addEventListener('click', () => {
      currentIndex = index;
      popup.style.display = 'block';
      popupImg.src = img.querySelector('img').src;
    });
  });

  // Nút điều hướng
  nextBtn.addEventListener('click', () => {
    currentIndex = (currentIndex + 1) % imgs2.length;
    popupImg.src = imgs2[currentIndex].src;
  });
  prevBtn.addEventListener('click', () => {
    currentIndex = (currentIndex - 1 + imgs2.length) % imgs2.length;
    popupImg.src = imgs2[currentIndex].src;
  });

  // Đóng popup
  closeBtn.addEventListener('click', () => popup.style.display = 'none');
  popup.addEventListener('click', e => {
    if (e.target === popup) popup.style.display = 'none';
  });
}

const SSaccordion = () => {
  const accordion = document.getElementById('ss-accordion');
  if (!accordion) return;
  const buttons = accordion.querySelectorAll('.card-header');
  if (!buttons.length) return;

  buttons.forEach(btn => {
    const panel = document.getElementById(btn.getAttribute('aria-controls'));

    btn.addEventListener('click', toggle);
    btn.addEventListener('keydown', function(e){
      if (e.key === 'Enter' || e.key === ' ' ) {
        e.preventDefault();
        toggle.call(this, e);
      }
    });

    function toggle() {
      const expanded = this.getAttribute('aria-expanded') === 'true';

      this.setAttribute('aria-expanded', String(!expanded));
      

      if (expanded) {
        this.classList.add('collapsed');
        panel.style.maxHeight = panel.scrollHeight + 'px'; // set chiều cao hiện tại
        requestAnimationFrame(() => {
          panel.style.maxHeight = '0';
        });
        panel.addEventListener('transitionend', function hidePanel() {
          panel.hidden = true;
          panel.removeEventListener('transitionend', hidePanel);
        });
      } else {
        this.classList.remove('collapsed');
        panel.hidden = false;
        panel.style.maxHeight = '0';
        requestAnimationFrame(() => {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        });
      }
    }

    // Giữ đúng chiều cao khi resize
    window.addEventListener('resize', () => {
      if (!panel.hidden) panel.style.maxHeight = panel.scrollHeight + 'px';
    });
  });


  // Mở sẵn phần tử đầu tiên
  if (buttons.length > 0) {
    const firstBtn = buttons[0];
    const firstPanel = document.getElementById(firstBtn.getAttribute('aria-controls'));
    firstBtn.setAttribute('aria-expanded', 'true');
    firstPanel.hidden = false;
    firstPanel.style.maxHeight = firstPanel.scrollHeight + 'px';
  }

}
const SSnavTabs = () => {
  document.querySelectorAll('.nav-tabs > div').forEach((tabItem) => {
      tabItem.addEventListener('click', () => {
        let target = tabItem.dataset.target;
        document.getElementById(target).classList.add('loading');
        document.querySelectorAll('.nav-tabs > div').forEach(b => b.classList.remove('active'));
        document.querySelectorAll('.tab-content > div').forEach(b => b.classList.remove('active'));
        document.querySelectorAll('.tabs-menu_title li').forEach(b => b.classList.remove('active'));
        tabItem.classList.add('active');   
        document.getElementById(target).classList.add('active');  
        setTimeout(() => {
          document.getElementById(target).classList.remove('loading');
        }, 500);           
      });
  });
  document.querySelectorAll('.tabs-menu_title li').forEach((tabItem) => {
      tabItem.addEventListener('click', () => {
        let target = tabItem.dataset.target;
        document.getElementById(target).classList.add('loading');
        document.querySelectorAll('.nav-tabs > div').forEach(b => b.classList.remove('active'));
        document.querySelectorAll('.tabs-menu_title li').forEach(b => b.classList.remove('active'));
        document.querySelectorAll('.tab-content > div').forEach(b => b.classList.remove('active'));
        document.querySelectorAll("select.tabs-menu_btn option").forEach(o => o.removeAttribute("selected"));
        document.querySelector('select.tabs-menu_btn option[value="'+target+'"]').setAttribute('selected', 'selected');
        tabItem.classList.add('active');   
        document.getElementById(target).classList.add('active');  
        setTimeout(() => {
          document.getElementById(target).classList.remove('loading');
        }, 500);           
      });
  });  

  const $this = document;
  const $nav = $this.querySelector('.tabs-menu');
   if (!$nav) return;
  const $subList = $nav.querySelector('ul');
  const time = 300;

  $nav.addEventListener('click', function (e) {
    const btn = e.target.closest('.open-title-menu');
    if (!btn) return;

    if ($subList.classList.contains('list-shown')) {
      document.querySelectorAll('.box-sellect').forEach(el => el.classList.remove('open'));
      btn.classList.remove('toggle-active');
      $subList.classList.remove('list-shown');
    } else {
      document.querySelectorAll('.box-sellect').forEach(el => el.classList.add('open'));
      btn.classList.add('toggle-active');
      $subList.classList.add('list-shown');

      setTimeout(() => {
        const bodyClickHandler = e2 => {
          const target = e2.target;
          if (!target.closest('.tabs-menu')) {
            btn.classList.remove('toggle-active');
            $subList.classList.remove('list-shown');
            document.body.removeEventListener('click', bodyClickHandler);
          }
        };
        document.body.addEventListener('click', bodyClickHandler);
      }, 10);
    }
  });  

  const select = document.querySelector('select.tabs-menu_btn');
    if (!select) return;

    select.addEventListener('change', e => {
      const target = e.target.value;

      // thêm class loading cho tab đang chọn
      const targetEl = document.getElementById(target);
      if (!targetEl) return;

      targetEl.classList.add('loading');

      // bỏ active ở tất cả tab và nội dung
      document.querySelectorAll('.nav-tabs > div').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.tab-content > div').forEach(b => b.classList.remove('active'));

      // thêm active cho tab & nội dung tương ứng
      const relatedTab = document.querySelector(`.nav-tabs > div[data-target="${target}"]`);
      if (relatedTab) relatedTab.classList.add('active');
      targetEl.classList.add('active');

      // tắt loading sau 500ms
      setTimeout(() => targetEl.classList.remove('loading'), 500);
  });
}
const SSswiperAll = () => {  
    document.querySelectorAll('.ss-swiper').forEach((swiperEl) => {
      // Parse data-breakpoints từ HTML (nó là JSON string)
      let breakpoints = {};
      try {
        breakpoints = JSON.parse(swiperEl.dataset.breakpoints || "{}");
      } catch (e) {
        console.warn("Sai format JSON trong data-breakpoints của", swiperEl, e);
      }
      const isAuto = swiperEl.dataset.auto === "true"; 
      const containerEl = swiperEl.closest('.swiper-container');
      // Lấy data attribute
      const config = {
        loop: swiperEl.dataset.loop === "true",
        effect: swiperEl.dataset.effect || "slide",
        slidesPerView: parseInt(swiperEl.dataset.slidesPerView || 1),
        spaceBetween: parseInt(swiperEl.dataset.spaceBetween || 0),
        autoplay: {
          delay: parseInt(swiperEl.dataset.delay || 3000),
          disableOnInteraction: false,
        },
        autoplay: isAuto ? {
          delay: parseInt(swiperEl.dataset.delay || 3000),
          disableOnInteraction: false,
        } : false,         
        pagination: {
          el: containerEl.querySelector(".swiper-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: containerEl.querySelector(".swiper-button-next"),
          prevEl: containerEl.querySelector(".swiper-button-prev"),
        },
        breakpoints: breakpoints, // responsive config     
      };

      // Tạo Swiper với config đọc từ data
      new Swiper(swiperEl, config);
    });
}


// ===================== SAFE STORAGE WRAPPER ===================== //
const SafeStorage = (() => {
  let memory = {};

  function available() {
    try {
      const test = '__test_ls__';
      localStorage.setItem(test, 'ok');
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  }

  const usable = available();

  return {
    get(key) {
      try {
        return usable ? localStorage.getItem(key) : (memory[key] || null);
      } catch {
        return null;
      }
    },
    set(key, value) {
      try {
        if (usable) localStorage.setItem(key, value);
        else memory[key] = value;
      } catch {}
    },
    remove(key) {
      try {
        if (usable) localStorage.removeItem(key);
        else delete memory[key];
      } catch {}
    },
    usable,
  };
})();

// ===================== WISHLIST ===================== //
const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';
const selectors = {
  button: '.action-link > .add-in-wishlist-js',
  grid: '[grid-wishlist]',
  productCard: '.product-content-wishlist',
};

document.addEventListener('DOMContentLoaded', () => {
  initButtonsWishlist();
  initGrid();
  updateWishlistCounter();
});

document.addEventListener('shopify-wishlist:updated', () => {
  initGrid();
  updateWishlistCounter();
});

const fetchProductCardHTML = async (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=wishlist`;
  try {
    const res = await fetch(productTileTemplateUrl);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const text = await res.text();
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
    return productCard ? productCard.outerHTML : '';
  } catch (err) {
    console.error(`[Shopify Content] Failed to load content for handle: ${handle}`, err);
    return '';
  }
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  if (!wishlist.length) {
    if (grid) {
      grid.innerHTML = '';
      grid.classList.remove(GRID_LOADED_CLASS);
    }
    document.querySelector('.wishlist__grid')?.classList.remove('loading_wishlist');
    document.querySelector('.wishlist_empty')?.classList.toggle('hidden', false);
    return;
  }

  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.filter(Boolean).join('');
  if (grid) {
    grid.innerHTML = wishlistProductCards;
    grid.classList.add(GRID_LOADED_CLASS);
  }

  initButtonsWishlist();
  if (typeof initButtonsCompare === 'function') initButtonsCompare();

  document.dispatchEvent(new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist }
  }));

  document.querySelector('.wishlist__grid')?.classList.remove('loading_wishlist');
  document.querySelector('.wishlist_empty')?.classList.toggle('hidden', wishlist.length > 0);
};

const setupButtonsWishlist = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return;
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);

    button.addEventListener('click', () => {
      // optimistic UI: update immediately in memory for snappy feel
      updateWishlist(productHandle);

      // animate/button feedback
      button.classList.add('load-wishlist');
      setTimeout(() => {
        button.classList.remove('load-wishlist');
        button.classList.toggle(BUTTON_ACTIVE_CLASS);
        const parent = button.closest('.action-link .add-in-wishlist-js');
        if (parent) {
          parent.setAttribute(
            'data-title',
            button.classList.contains('active') ? (window.strings?.remove_wishlist || '') : (window.strings?.wishlist || '')
          );
        }
      }, 300);
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtonsWishlist = ($element) => {
  const root = $element ? document.querySelector($element) : document;
  if (!root) return;
  const buttons = Array.from(root.querySelectorAll(selectors.button) || []);
  if (!buttons.length) return;
  setupButtonsWishlist(buttons);

  document.dispatchEvent(new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  }));

  buttons.forEach(button => {
    const parent = button.closest('.product-wishlist') || button.closest('.action-link');
    if (!parent) return;
    parent.setAttribute(
      'data-title',
      button.classList.contains('active') ? (window.strings?.remove_wishlist || '') : (window.strings?.wishlist || '')
    );
  });
};

const updateWishlistCounter = () => {
  const wishlist = getWishlist();
  const el = document.querySelector('.header__wishlist span');
  if (el) el.textContent = String(wishlist.length);
};

// STORAGE: get/set using SafeStorage
const getWishlist = () => {
  const wishlist = SafeStorage.get(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER).map(s => s.trim()).filter(Boolean);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) SafeStorage.set(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else SafeStorage.remove(LOCAL_STORAGE_WISHLIST_KEY);

  document.dispatchEvent(new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  }));
  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);

  updateWishlistCounter();
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};


//compare
const LOCAL_STORAGE_COMPARE_KEY = 'shopify-compare';
const LOCAL_STORAGE_DELIMITER_COMPARE = ',';
const BUTTON_ACTIVE_CLASS_COMPARE = 'active';
const GRID_LOADED_CLASS_COMPARE = 'loaded';
const selectorscompare = {
	button: '.button-compare >button',
	remove: '.remove-compare >button',
	grid: '[grid-compare]',
	table: '.compare-page',
	productCard: '.product-content-compare',
};
document.addEventListener('DOMContentLoaded', () => {
  initButtonsCompare();  
	initGridCompare();
	const compare = getCompare();
	if(compare.length === 0){        
    document.querySelector(selectorscompare.table)?.classList.remove(GRID_LOADED_CLASS_COMPARE);
	}else{
		document.querySelector(selectorscompare.table).classList.add(GRID_LOADED_CLASS_COMPARE);
    const countEl = document.querySelector(selectorscompare.table).querySelectorAll('.show-compare .count');
    if (countEl) {
      countEl.textContent = compare.length;
    }
	}
});
document.addEventListener('shopify-compare:updated', (event) => {
	initGridCompare();
});
const fetchProductCardHTMLCOMPARE = (handle) => {
	const productTileTemplateUrl = `/products/${handle}?view=compare`;
	return fetch(productTileTemplateUrl)
	.then((res) => res.text())
	.then((res) => {
		const text = res;
		const parser = new DOMParser();
		const htmlDocument = parser.parseFromString(text, 'text/html');
		const productCard = htmlDocument.documentElement.querySelector(selectorscompare.productCard);
		return productCard.outerHTML;
	})
	.catch((err) => console.error(`[Shopify Content] Failed to load content for handle: ${handle}`, err));
};
const setupGridCompare = async (grid) => {
	const compare = getCompare();
	const requests = compare.map(fetchProductCardHTMLCOMPARE);
  if (requests && Array.isArray(requests)) {

    // Danh sách các selector và class tương ứng để tránh lặp code
    const mapping = [
      { clone: '.clone-remove-compare', target: '.remove-button' },
      { clone: '.clone-compare-title', target: '.compare-product_name' },
      { clone: '.clone-compare-image', target: '.compare-product_image' },
      { clone: '.clone-compare-card__content', target: '.compare-product_variants' },
      { clone: '.clone-compare-inventory', target: '.compare-product_availability' },
      { clone: '.clone-compare-price', target: '.compare-product_price' },
      { clone: '.clone-compare-atc', target: '.compare-product_atc' }
    ];

    // Lặp qua từng promise trong requests
    requests.forEach((result) => {
      result.then(
        (value) => {
          const doc = new DOMParser().parseFromString(value, 'text/html');

          // Lặp qua mapping để thêm từng loại nội dung
          mapping.forEach(({ clone, target }) => {
            const contentElement = doc.querySelector(clone);
            if (!contentElement) return;

            const container = document.querySelector(`${selectorscompare.table} ${target}`);
            if (container) {
              const div = document.createElement('div');
              div.innerHTML = contentElement.innerHTML;
              container.appendChild(div);
            }
          });
        },
        (error) => {
          console.error(error);
        }
      );
    });
  }

	const responses = await Promise.all(requests);
	const compareProductCards = responses.join('');
  
  document.body.addEventListener('submit', function (evt) {
    // Kiểm tra xem form có đúng selector không
    const form = evt.target.closest('.product-card__form [data-product-form]');
    if (!form) return;

    evt.preventDefault();

    const formData = new FormData(form);
    const handle = formData.get('handle');
    const title = formData.get('title');
    const id = formData.get('id');

    // Lấy hình ảnh theo handle
    const imgEl = document.querySelector(`.product-card__image_compare[data-handle="${handle}"] img`);
    const image = imgEl ? imgEl.getAttribute('src') : '';

    // Gọi hàm thêm vào giỏ hàng
    doAjaxAddToCart(id, 1, title, image);
  });

	removeCompare();
	const event = new CustomEvent('shopify-compare:init-product-grid', {
		detail: { compare: compare }
	});
	document.dispatchEvent(event);
};
const setupButtonsCompare = (buttons) => {
	buttons.forEach((button) => {
		const productHandle = button.dataset.productHandle || false;
		if (!productHandle) return;
		if (compareContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS_COMPARE);
		button.addEventListener('click', () => {
    if (!button.classList.contains('active')) {
      const table = document.querySelector(selectorscompare.table);
      if (table) {
        const contentCompare = table.querySelector('.content-compare');
        const content = table.querySelector('.content');
        if (contentCompare) contentCompare.classList.add('active');
        if (content) content.classList.add('load-compare');
      }
    }
			const timeCompare = setTimeout(loadCompare, 1000);
			updateCompare(productHandle);
			button.classList.add('load-compare');
			function loadCompare() {
				button.classList.remove('load-compare');
        const table = document.querySelector(selectorscompare.table);
        const content = table.querySelector('.content');
        if (content) content.classList.remove('load-compare');

        // Toggle class active
        button.classList.toggle(BUTTON_ACTIVE_CLASS_COMPARE);

        // Kiểm tra nếu có class active
        const parent = button.closest('.button-compare');
        if (parent) {
          if (button.classList.contains('active')) {
            parent.setAttribute('data-title', window.strings.remove_compare);
          } else {
            parent.setAttribute('data-title', window.strings.compare);
          }
        }
			}
			return ;
		});
	});
};
const removeButtonsCompare = (buttons) => {
	buttons.forEach((remove) => {
		const productHandle = remove.dataset.productHandle || false;
		if (!productHandle) return;
		if (compareContains(productHandle)) remove.classList.add(BUTTON_ACTIVE_CLASS_COMPARE);
		remove.addEventListener('click', () => {
			const timeCompare = setTimeout(loadCompare, 1000);
			updateCompare(productHandle);
      // Thêm class "load-compare"
      const table = document.querySelector(selectorscompare.table);
      const content = table ? table.querySelector('.content') : null;
      if (content) {
        content.classList.add('load-compare');
      }

      function loadCompare() {
        if (content) {
          content.classList.remove('load-compare');
        }
        const handle = remove.getAttribute('data-product-handle');
        // Xóa class active khỏi button theo handle
        document.querySelectorAll(`.button-compare > button[data-product-handle="${handle}"]`)
          .forEach(btn => btn.classList.remove(BUTTON_ACTIVE_CLASS_COMPARE));

        // Cập nhật title cho từng nút compare
        const buttons = document.querySelectorAll(selectorscompare.button);
        buttons.forEach(button => {
          const parent = button.closest('.button-compare');
          if (!parent) return;

          if (button.classList.contains('active')) {
            parent.setAttribute('data-title', window.strings.remove_compare);
          } else {
            parent.setAttribute('data-title', window.strings.compare);
          }
        });
      }

		});
	});
}
const initGridCompare = () => {
	const grid = document.querySelector(selectorscompare.grid) || false;
  if (grid) {
    const table = document.querySelector(selectorscompare.table);
    if (table) {
      const selectors = [
        '.remove-button',
        '.compare-product_name',
        '.compare-product_image',
        '.compare-product_variants',
        '.compare-product_availability',
        '.compare-product_price',
        '.compare-product_atc'
      ];
      selectors.forEach(sel => {
        const el = table.querySelector(sel);
        if (el) el.innerHTML = '';
      });
    }

    setupGridCompare(grid);
  }

  // Ẩn bảng so sánh
  const hideBtn = document.querySelector('.compare-page .hide-button-compare');
  if (hideBtn) {
    hideBtn.addEventListener('click', () => {
      const content = document.querySelector('.compare-page .content-compare');
      if (content && content.classList.contains('active')) {
        content.classList.remove('active');
      }
    });
  }

  // Hiện bảng so sánh
  const showBtn = document.querySelector('.compare-page .show-compare');
  if (showBtn) {
    showBtn.addEventListener('click', () => {
      const content = document.querySelector('.compare-page .content-compare');
      if (content && !content.classList.contains('active')) {
        content.classList.add('active');
      }
    });
  }

};
const initButtonsCompare = ($element) => {
	if($element){
		const parentElement = document.querySelector($element);
		let buttons = parentElement.querySelectorAll(selectorscompare.button) || [];
		if (buttons.length){
			setupButtonsCompare(buttons);
		}else return;
	}else{
		const buttons = document.querySelectorAll(selectorscompare.button) || [];
		if (buttons.length){
			setupButtonsCompare(buttons);
		}else return;	
	}
	const event = new CustomEvent('shopify-compare:init-buttons', {
		detail: { compare: getCompare() }
	});
	document.dispatchEvent(event);
  document.querySelectorAll(selectorscompare.button).forEach(button => {
    const parent = button.closest('.button-compare');
    if (!parent) return;
    parent.setAttribute(
      'data-title',
      button.classList.contains('active')
        ? window.strings.remove_compare
        : window.strings.compare
    );
  });
};
const removeCompare = () => {
	const buttons = document.querySelectorAll(selectorscompare.remove) || [];
	if (buttons.length){
		removeButtonsCompare(buttons);
	}
	else return;
	const event = new CustomEvent('shopify-compare:init-buttons', {
		detail: { compare: getCompare() }
	});
	document.dispatchEvent(event);
};
const getCompare = () => {
	const compare = localStorage.getItem(LOCAL_STORAGE_COMPARE_KEY) || false;
	if (compare) return compare.split(LOCAL_STORAGE_DELIMITER_COMPARE);
	return [];
};
const setCompare = (array) => {
	const compare = array.join(LOCAL_STORAGE_DELIMITER_COMPARE);
  
	if (array.length) localStorage.setItem(LOCAL_STORAGE_COMPARE_KEY, compare);
		else localStorage.removeItem(LOCAL_STORAGE_COMPARE_KEY);
		const event = new CustomEvent('shopify-compare:updated', {
		detail: { compare: array }
	});
	document.dispatchEvent(event);
	return compare;
};
const updateCompare = (handle) => {
	const compare = getCompare();
	const indexInCompare = compare.indexOf(handle);
	const table = document.querySelector(selectorscompare.table);

	if (indexInCompare === -1) {
		compare.push(handle);
	}else{
		compare.splice(indexInCompare, 1);
	}

    if (compare.length === 0) {
      const compareContent = document.querySelector('.compare-page .content-compare');
      if (compareContent?.classList.contains('active')) {
        compareContent.classList.remove('active');
      }
    }
	if(compare.length === 0){
		table.classList.remove(GRID_LOADED_CLASS_COMPARE);
	}else{
		table.classList.add(GRID_LOADED_CLASS_COMPARE);
	}
	return setCompare(compare);
};
const compareContains = (handle) => {
	const compare = getCompare();
	return compare.includes(handle);
};
const resetCompare = () => {
	return setCompare([]);
};


